<template>
    <rkm-form ref="RkmForm">
        <rkm-area
            no-margin-top
            title="Título de eleitor"
        >
            <rkm-row>
                <rkm-col cols="2">
                    <rkm-form-input
                        :validations="validations.titulo_eleitor_numero"
                        label="Número"
                        uppercase
                        v-model="model.titulo_eleitor_numero"
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-select
                        :disabled="!model.titulo_eleitor_numero"
                        :options="form.estados"
                        :validations="validations.titulo_eleitor_estado_id"
                        label="UF"
                        show-default-option
                        text-field="uf"
                        v-model="model.titulo_eleitor_estado_id"
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-input-autocomplete
                        :disabled="!model.titulo_eleitor_estado_id"
                        :fields="fields.municipio"
                        :repository="repositories.comum.municipio"
                        :request-params="{estado_id: model.titulo_eleitor_estado_id}"
                        :selected-text="model.titulo_eleitor_municipio_nome"
                        :validations="validations.titulo_eleitor_municipio_id"
                        label="Município"
                        v-model="model.titulo_eleitor_municipio_id"
                    />
                </rkm-col>

                <rkm-col cols="2">
                    <rkm-form-input
                        :disabled="!model.titulo_eleitor_numero"
                        :validations="validations.titulo_eleitor_zona"
                        label="Zona"
                        uppercase
                        v-model="model.titulo_eleitor_zona"
                    />
                </rkm-col>

                <rkm-col cols="2">
                    <rkm-form-input
                        :disabled="!model.titulo_eleitor_numero"
                        :validations="validations.titulo_eleitor_secao"
                        label="Seção"
                        uppercase
                        v-model="model.titulo_eleitor_secao"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <rkm-area
            no-margin-top
            title="Carteira de identidade (RG)"
        >
            <rkm-row>
                <rkm-col cols="4">
                    <rkm-form-input
                        :validations="validations.rg_numero"
                        label="Número"
                        uppercase
                        v-model="model.rg_numero"
                    />
                </rkm-col>

                <rkm-col cols="4">
                    <rkm-form-select
                        :disabled="!model.rg_numero"
                        :options="form.estados"
                        :validations="validations.rg_estado_id"
                        label="UF"
                        show-default-option
                        text-field="uf"
                        v-model="model.rg_estado_id"
                    />
                </rkm-col>

                <rkm-col cols="4">
                    <rkm-form-datepicker
                        :disabled="!model.rg_numero"
                        :max-date="additionals.data_atual"
                        :min-date="others.moment(model.data_nascimento).format('DD/MM/YYYY')"
                        label="Data de emissão"
                        right
                        v-model="model.rg_data_emissao"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <rkm-area
            no-margin-top
            title="Certidão"
        >
            <rkm-row>
                <rkm-col cols="3">
                    <rkm-form-select
                        :options="form.certidao_tipos"
                        :validations="validations.certidao_tipo_id"
                        label="Tipo de certidão"
                        show-default-option
                        text-field="descricao"
                        v-model="model.certidao_tipo_id"
                        value-field="id"
                    />
                </rkm-col>

                <rkm-col class="flex-grow-0 text-nowrap">
                    <rkm-form-radio-group
                        :disabled="!model.certidao_tipo_id"
                        :options="form.certidao_modelos"
                        :validations="validations.certidao_modelo_id"
                        label="Modelo"
                        text-field="nome"
                        v-model="model.certidao_modelo_id"
                        value-field="id"
                    />
                </rkm-col>

                <rkm-col v-if="model.certidao_modelo_id === enums.CertidaoModelo.NOVO">
                    <rkm-form-input
                        :disabled="!model.certidao_tipo_id"
                        :validations="validations.certidao_numero"
                        label="Número"
                        v-mask="utils.mask.certidao"
                        v-model="model.certidao_numero"
                    />
                </rkm-col>

                <rkm-col v-else>
                    <rkm-form-input
                        :disabled="!model.certidao_tipo_id"
                        :validations="validations.certidao_termo"
                        label="Termo"
                        uppercase
                        v-model="model.certidao_termo"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row v-if="model.certidao_modelo_id === enums.CertidaoModelo.ANTIGO">
                <rkm-col cols="4">
                    <rkm-form-input
                        :disabled="!model.certidao_termo"
                        :validations="validations.certidao_cartorio_nome"
                        label="Nome do cartório"
                        uppercase
                        v-model="model.certidao_cartorio_nome"
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-input
                        :disabled="!model.certidao_termo"
                        :validations="validations.certidao_livro"
                        label="Livro"
                        uppercase
                        v-model="model.certidao_livro"
                    />
                </rkm-col>

                <rkm-col cols="2">
                    <rkm-form-input
                        :disabled="!model.certidao_termo"
                        :validations="validations.certidao_folha"
                        label="Folha"
                        uppercase
                        v-model="model.certidao_folha"
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-datepicker
                        :disabled="!model.certidao_termo"
                        :max-date="additionals.data_atual"
                        :min-date="others.moment(model.data_nascimento).format('DD/MM/YYYY')"
                        :validations="validations.certidao_data_emissao"
                        label="Data de emissão"
                        right
                        v-model="model.certidao_data_emissao"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row v-if="model.certidao_modelo_id === enums.CertidaoModelo.ANTIGO">
                <rkm-col cols="2">
                    <rkm-form-select
                        :disabled="!model.certidao_termo"
                        :options="form.estados"
                        :validations="validations.certidao_estado_id"
                        label="UF"
                        show-default-option
                        text-field="uf"
                        v-model="model.certidao_estado_id"
                    />
                </rkm-col>

                <rkm-col cols="6">
                    <rkm-form-input-autocomplete
                        :disabled="!model.certidao_estado_id"
                        :fields="fields.municipio"
                        :repository="repositories.comum.municipio"
                        :request-params="{estado_id: model.certidao_estado_id}"
                        :selected-text="model.certidao_municipio_nome"
                        :validations="validations.certidao_municipio_id"
                        label="Município"
                        v-model="model.certidao_municipio_id"
                    />
                </rkm-col>

                <rkm-col cols="4">
                    <rkm-form-input
                        :disabled="!model.certidao_termo"
                        :validations="validations.certidao_cartorio_codigo"
                        label="Código do cartório"
                        uppercase
                        v-model="model.certidao_cartorio_codigo"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <rkm-area
            no-margin-top
            title="Carteira de trabalho (CTPS)"
        >
            <rkm-row>
                <rkm-col cols="2">
                    <rkm-form-input
                        :validations="validations.ctps_numero"
                        label="Número"
                        uppercase
                        v-model="model.ctps_numero"
                    />
                </rkm-col>

                <rkm-col cols="2">
                    <rkm-form-input
                        :disabled="!model.ctps_numero"
                        :validations="validations.ctps_serie"
                        label="Série"
                        uppercase
                        v-model="model.ctps_serie"
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-datepicker
                        :disabled="!model.ctps_numero"
                        :max-date="additionals.data_atual"
                        :min-date="others.moment(model.data_nascimento).format('DD/MM/YYYY')"
                        :validations="validations.ctps_data_emissao"
                        label="Data de emissão"
                        v-model="model.ctps_data_emissao"
                    />
                </rkm-col>

                <rkm-col cols="2">
                    <rkm-form-select
                        :disabled="!model.ctps_numero"
                        :options="form.estados"
                        :validations="validations.ctps_estado_id"
                        label="UF"
                        show-default-option
                        text-field="uf"
                        v-model="model.ctps_estado_id"
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-input
                        :disabled="!model.ctps_numero"
                        :validations="validations.ctps_nis_pis_pasep"
                        label="NIS | PIS / PASEP"
                        number
                        v-model="model.ctps_nis_pis_pasep"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <rkm-area
            no-margin-top
            title="Carteira nacional de habilitação (CNH)"
        >
            <rkm-row>
                <rkm-col cols="2">
                    <rkm-form-input
                        :validations="validations.cnh_numero"
                        label="Número"
                        number
                        v-model="model.cnh_numero"
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-datepicker
                        :disabled="!model.cnh_numero"
                        :max-date="additionals.data_atual"
                        :min-date="others.moment(model.data_nascimento).format('DD/MM/YYYY')"
                        :validations="validations.cnh_data_emissao"
                        label="Data de emissão"
                        v-model="model.cnh_data_emissao"
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-datepicker
                        :disabled="!model.cnh_numero"
                        :min-date="others.moment(model.cnh_data_emissao).format('DD/MM/YYYY')"
                        :validations="validations.cnh_data_validade"
                        label="Data de validade"
                        v-model="model.cnh_data_validade"
                    />
                </rkm-col>

                <rkm-col cols="2">
                    <rkm-form-select
                        :disabled="!model.cnh_numero"
                        :options="form.estados"
                        :validations="validations.cnh_estado_id"
                        label="UF"
                        show-default-option
                        text-field="uf"
                        v-model="model.cnh_estado_id"
                    />
                </rkm-col>

                <rkm-col cols="2">
                    <rkm-form-select
                        :disabled="!model.cnh_numero"
                        :options="form.cnh_categorias"
                        :validations="validations.cnh_categoria_id"
                        label="Categoria"
                        show-default-option
                        text-field="letra"
                        v-model="model.cnh_categoria_id"
                        value-field="id"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <rkm-area
            no-margin-top
            title="Estrangeiro"
        >
            <rkm-row>
                <rkm-col cols="3">
                    <rkm-form-input
                        :validations="validations.rne_numero"
                        label="RNE"
                        uppercase
                        v-model="model.rne_numero"
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-datepicker
                        :disabled="!model.rne_numero"
                        :max-date="additionals.data_atual"
                        :min-date="others.moment(model.data_nascimento).format('DD/MM/YYYY')"
                        :validations="validations.data_entrada_brasil"
                        label="Data de entrada no Brasil"
                        v-model="model.data_entrada_brasil"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-area>
    </rkm-form>
</template>

<script>
// Enums.
import {CertidaoModelo} from '@/enums'

// Others.
import moment from 'moment'

// Utils.
import mask from '@/utils/mask'

export default {
    computed: {
        fields() {
            return {
                municipio: [
                    {key: 'nome', name: 'cadastro_municipio.nome'},
                ],
            }
        },
        validations() {
            return {
                titulo_eleitor_estado_id: {required: true},
                titulo_eleitor_municipio_id: {required: true},
                rg_estado_id: {required: true},
                certidao_modelo_id: {required: true},
                certidao_estado_id: {required: true},
                certidao_municipio_id: {required: true},
                ctps_estado_id: {required: true},
                cnh_estado_id: {required: true},
                cnh_categoria_id: {required: true},
                titulo_eleitor_numero: {
                    min: 9,
                    max: 13,
                },
                titulo_eleitor_zona: {
                    required: true,
                    min: 3,
                    max: 4,
                },
                titulo_eleitor_secao: {
                    required: true,
                    min: 4,
                    max: 4,
                },
                rg_numero: {
                    min: 6,
                    max: 15,
                },
                certidao_numero: {
                    required: true,
                    min: 40,
                    max: 40,
                },
                certidao_termo: {
                    required: true,
                    min: 8,
                    max: 40,
                },
                certidao_cartorio_nome: {
                    required: true,
                    min: 3,
                    max: 70,
                },
                certidao_livro: {
                    required: true,
                    max: 8,
                },
                certidao_folha: {
                    required: true,
                    min: 4,
                    max: 10,
                },
                certidao_data_emissao: {required: true},
                certidao_cartorio_codigo: {
                    required: true,
                    min: 15,
                    max: 15,
                },
                ctps_numero: {
                    min: 7,
                    max: 16,
                },
                ctps_serie: {
                    required: true,
                    min: 5,
                    max: 5,
                },
                ctps_data_emissao: {required: true},
                ctps_nis_pis_pasep: {
                    required: true,
                    min: 11,
                    max: 11,
                },
                cnh_numero: {
                    min: 11,
                    max: 11,
                },
                cnh_data_emissao: {required: true},
                cnh_data_validade: {required: true},
                rne_numero: {max: 20},
                data_entrada_brasil: {required: true},
            }
        },
    },
    data: () => ({
        enums: {CertidaoModelo},
        others: {moment},
        utils: {mask},
    }),
    inject: ['repositories'],
    methods: {
        validate() {
            return this.$refs.RkmForm.validate()
        },
    },
    props: {
        additionals: {type: Object, required: true},
        form: {type: Object, required: true},
        model: {type: Object, required: true},
    },
    watch: {
        'model.titulo_eleitor_estado_id'() {
            this.model.titulo_eleitor_municipio_id = null
            this.model.titulo_eleitor_municipio_nome = null
        },
        'model.certidao_tipo_id'(value) {
            if (!value) {
                this.model.certidao_estado_id = null
                this.model.certidao_municipio_id = null
                this.model.certidao_numero = null
                this.model.certidao_termo = null
                this.model.certidao_cartorio_nome = null
                this.model.certidao_livro = null
                this.model.certidao_folha = null
                this.model.certidao_data_emissao = null
                this.model.certidao_municipio_nome = null
                this.model.certidao_cartorio_codigo = null
            }
        },
        'model.certidao_modelo_id'(value) {
            if (value === this.enums.CertidaoModelo.NOVO) {
                this.model.certidao_estado_id = null
                this.model.certidao_municipio_id = null
                this.model.certidao_termo = null
                this.model.certidao_cartorio_nome = null
                this.model.certidao_livro = null
                this.model.certidao_folha = null
                this.model.certidao_data_emissao = null
                this.model.certidao_municipio_nome = null
                this.model.certidao_cartorio_codigo = null
            }
            else if (value === this.enums.CertidaoModelo.ANTIGO) {
                this.model.certidao_numero = null
            }
        },
        'model.titulo_eleitor_numero'(value) {
            if (!value) {
                this.model.titulo_eleitor_estado_id = null
                this.model.titulo_eleitor_municipio_id = null
                this.model.titulo_eleitor_municipio_nome = null
                this.model.titulo_eleitor_zona = null
                this.model.titulo_eleitor_secao = null
            }
        },
        'model.rg_numero'(value) {
            if (!value) {
                this.model.rg_estado_id = null
                this.model.rg_data_emissao = null
            }
        },
        'model.ctps_numero'(value) {
            if (!value) {
                this.model.ctps_estado_id = null
                this.model.ctps_serie = null
                this.model.ctps_data_emissao = null
                this.model.ctps_nis_pis_pasep = null
            }
        },
        'model.cnh_numero'(value) {
            if (!value) {
                this.model.cnh_estado_id = null
                this.model.cnh_data_emissao = null
                this.model.cnh_data_validade = null
                this.model.cnh_categoria_id = null
            }
        },
        'model.rne_numero'(value) {
            if (!value) {
                this.model.data_entrada_brasil = null
            }
        },
    },
}
</script>